import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Partner } from 'src/app/models/Partner';
import { map } from 'rxjs/operators';
import { MainService } from '../../delavci/main.service';
import { Constants } from 'src/app/utils/constants';
import { AppConfigServiceService } from '../../app-config-service.service';
import { HelpersService } from '../../shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class LoginPartnerService {

  public currentPartnerSubject: BehaviorSubject<Partner>;
  public currentPartner: Observable<Partner>;

  public currentSessionSubject: BehaviorSubject<string>;
  public currentSession: Observable<string>;

  public curHostname;
  constructor(private http: HttpClient, private MY_CONSTANTS: Constants,
    private appConfigService: AppConfigServiceService, private helpersService: HelpersService) {
    this.currentPartnerSubject = new BehaviorSubject<Partner>(JSON.parse(localStorage.getItem('loggedPartner')));
    this.currentPartner = this.currentPartnerSubject.asObservable();

    this.currentSessionSubject = new BehaviorSubject<string>(JSON.stringify(localStorage.getItem('sessionUser')));
    this.currentSession = this.currentSessionSubject.asObservable();

    this.helpersService.currentHostname.subscribe( data => {
      this.curHostname = data;
    });
  }

  public get currentPartnerValue(): Partner {
    return this.currentPartnerSubject.value;
  }

  public get currentSessionValue(): string {
    return this.currentSessionSubject.value;
  }

  getSession() {
    const params = new HttpParams()
    .set('domain', 'portal.bilumina.com');
    return this.http.post<any>(this.curHostname + this.appConfigService.apiWeb + 'omnichannel/getSession', params.toString());
  }

  loginPartner(sessionUser: string, username: string, password: string) {
    const params = new HttpParams()
    .set('sessionUser', sessionUser)
    .set('domain', 'portal.bilumina.com')
    .set('page', 'HOME')
    .set('username', username)
    .set('password', password);
    return this.http.post<any>(this.curHostname + this.appConfigService.apiWeb + 'omnichannel/login', params.toString());
  }

  loginPartnerWithToken(sessionUser, token: string) {
    const params = new HttpParams()
    .set('token', token)
    .set('sessionUser', sessionUser)
    .set('domain', 'portal.bilumina.com')
    .set('page', 'HOME');
    return this.http.post<any>(this.curHostname + this.appConfigService.apiWeb + 'omnichannel/login', params);
  }
  setCurrentPartner(partner: Partner) {
    localStorage.setItem('loggedPartner', JSON.stringify(partner));
    this.currentPartnerSubject.next(partner);
  }

  setCurrentSession(sessionUser: string) {
    localStorage.setItem('sessionUser', JSON.stringify(sessionUser));
    this.currentSessionSubject.next(sessionUser);
  }

  logout() {
    localStorage.removeItem('loggedPartner');
    localStorage.removeItem('sessionUser');
    this.currentPartnerSubject.next(null);
  }
}
